import apiClient from './apiClient';
import { User } from '../types/auth';

// ページネーションレスポンスの型定義
interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

// ユーザー一覧を取得
export const getUsers = async (): Promise<User[] | PaginatedResponse<User>> => {
  try {
    const response = await apiClient.get<User[] | PaginatedResponse<User>>('/app_users/');
    return response.data;
  } catch (error) {
    console.error('getUsers API error:', error);
    throw error;
  }
};

// ユーザーを作成
export const createUser = async (userData: any): Promise<User> => {
  // バックエンドの要件に合わせてデータを整形
  const formattedData = {
    ...userData,
    // UserCreateSerializerではpassword_confirmを期待しているが、
    // RegisterSerializerではpassword2を期待している
    password2: userData.password_confirm,
    // Userモデルがusername=Noneだが、create_userメソッドはusernameを必要とする
    // emailを一意な識別子としてusernameに使用
    username: userData.email,
    // is_staffとis_superuserは常にfalse
    is_staff: false,
    is_superuser: false
  };

  try {
    const response = await apiClient.post<User>('/app_users/', formattedData);
    return response.data;
  } catch (error: any) {
    // 詳細なエラーメッセージをコンソールに表示
    console.error("API Error details:", error.response?.data);
    throw error;
  }
};

// ユーザーを更新
export const updateUser = async (userId: number, userData: any): Promise<User> => {
  // 現在のユーザー情報を取得して必要なフィールドだけを更新する
  // is_staff, is_superuserは既存値を維持
  const formattedData = {
    ...userData,
    // usernameを更新（emailが変更された可能性がある）
    username: userData.email,
    // システム管理者のフラグは送信しない（既存値が維持される）
    is_staff: undefined,
    is_superuser: undefined
  };
  
  try {
    const response = await apiClient.put<User>(`/app_users/${userId}/`, formattedData);
    return response.data;
  } catch (error: any) {
    console.error("API Error details:", error.response?.data);
    throw error;
  }
};

